import { EnvGroup } from '@flakiness/server/common/stats/envGroup.js';
import { WireTypes } from '@flakiness/server/common/wireTypes.js';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { renderCategoryIcon, renderDotSeparated } from '../fragments.js';
import { hrefOrClick, Linkifier } from '../linkifier.js';
import { linkStyles } from './cssstyles.js';

@customElement('fk-runenvs')
class FKRunEnvs extends LitElement {

  @property({ attribute: false }) run?: WireTypes.WellformedRun;
  @property({ attribute: false }) runlinker?: Linkifier<WireTypes.WellformedRun>;

  render() {
    const run = this.run;
    const envs = run?.environments;
    if (!run || !envs || !envs.length)
      return nothing;
    const category = envs[0].category;
    const envNames = Array.from(new Set(envs.map(env => env.name)));
    const osLabels = Array.from(new Set(envs.map(env => EnvGroup.osLabel(env.systemData)))).filter(Boolean);
    return html`
      <v-box class=run>
        <a ${hrefOrClick(this.runlinker?.(run))}>
          <h-box class=title>
            ${renderCategoryIcon(category)}
            ${renderDotSeparated(envNames.map(envName => html`<span>${envName}</span>`))}
          </h-box>
        </a>
        ${osLabels.length ? html`
          <h-box class=details>
            ${renderDotSeparated(osLabels.map(osLabel => html`<span>${osLabel}</span>`))}
          </h-box>
        ` : nothing}
      </v-box>
    `;
  }

  static styles = [linkStyles, css`
    sl-icon {
      flex: none;
    }

    .run {
      gap: var(--sl-spacing-x-small);

      .title {
        font-weight: var(--sl-font-weight-semibold);
        gap: var(--sl-spacing-2x-small);
        flex-wrap: wrap;
      }
    }

    .details {
      font-size: var(--sl-font-size-small);
      color: var(--sl-color-neutral-500);
      gap: var(--sl-spacing-2x-small);
    }
  `];
}
